// Firebase could not start at all: no config, or no network to fetch it with.
//
// Without it there is no auth and no API, so a page that renders anyway is a
// page whose every request will fail. Its own file rather than a local function
// in App.tsx because /start needs it too, and App imports Start.
//
// "/" is deliberately not behind this -- the marketing page needs none of it,
// and a visitor deciding whether we are a real company should not be met with
// our stack trace.

import { PRODUCT_NAME } from "../lib/brand";

export default function StartupFailure({ message }: { message: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="max-w-md rounded-xl border border-red-200 bg-surface p-6 text-center">
        <h1 className="text-base font-medium text-slate-900">{PRODUCT_NAME} could not start</h1>
        <p className="mt-2 text-sm text-slate-600">
          We couldn't load the app's configuration. Check your connection and reload.
        </p>
        <p className="mt-3 font-mono text-xs text-slate-400">{message}</p>
      </div>
    </div>
  );
}
